import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class PageUSPs extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--' + block.bg_color}>
			    
			    	<div className="c-page__block__inner">
			    		
			    		{block.heading && block.text &&
			    			<div className="c-usps__text">
				    			<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:'<h2>' + block.heading + '</h2>' + block.text}}></div>
				    		</div>
			    		}
			    		
			    		{block.heading && !block.text &&
				    		<div className="c-usps__text">
				    			<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:'<h2>' + block.heading + '</h2>'}}></div>
				    		</div>
			    		}
			    		
			    		{!block.heading && block.text &&
				    		<div className="c-usps__text">
				    			<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
				    		</div>
			    		}
				    		
			    		<div className={'c-usps c-usps--' + block.formatting + ' c-usps--' + block.layout}>
			    		
			    			
			    		
			    			{block.point.map((point,i) =>
								{
									if (point.src) {
										return (
											<div className="c-usps__item">
												<div className="c-usps__item__inner">
													<div className="c-usps__item__icon">
														<Image srcset={point.srcset} src={point.src} />
													</div>
													<h4 className="c-usps__item__text" dangerouslySetInnerHTML={{__html:point.label}}></h4>
												</div>
											</div>
										)
									} else if (point.svg_code) {
										return (
											<div className="c-usps__item">
												<div className="c-usps__item__inner">
													<div className="c-usps__item__icon" dangerouslySetInnerHTML={{__html:point.svg_code}}></div>
													<h4 className="c-usps__item__text" dangerouslySetInnerHTML={{__html:point.label}}></h4>
												</div>
											</div>
										)
									} else {
										return (
											<div className="c-usps__item">
												<div className="c-usps__item__inner">
													<h4 className="c-usps__item__text" dangerouslySetInnerHTML={{__html:point.label}}></h4>
												</div>
											</div>
										)
									}
								}
							)}
			    		
			    		</div>
			    		
			    	</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
